module.exports = __webpack_public_path__ + "img/code3.ac3dd818.png";